import { applyFocusVisible } from "@microsoft/fast-jss-utilities";
const styles = {
    treeView: Object.assign({ display: "flex", "flex-direction": "column", "align-items": "stretch", "min-width": "fit-content", "font-size": "0" }, applyFocusVisible({})),
};
export default styles;
